module.exports = __webpack_public_path__ + "static/media/img-passos.a47432da.png";